import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Radio,
  RadioGroup,
  SimpleGrid,
} from '@chakra-ui/react';
import isEmpty from 'lodash/isEmpty';

import { useModalManagerContext } from '../../components/ModalManager/ModalManagerContext';

import { CancelReasons } from './cancelReasons';

const ReasonSelectorModal: React.FC<{ reasonsToMap: Reason[] }> = ({
  reasonsToMap,
}) => {
  const { t } = useTranslation();
  const { onClose, setData, startFlow } = useModalManagerContext();

  const [reason, setReason] = useState<CancelReasons | undefined>();

  const handleOnReasonChange = (value) => {
    setData({ reason: value });
    setReason(value);
  };

  const handleMainButtonClick = () => {
    startFlow(reason);
  };

  const handleOnClose = () => {
    onClose();
  };

  return (
    <>
      <ModalHeader>{t('cancelModal.header')}</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <RadioGroup onChange={handleOnReasonChange} value={reason}>
          <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
            {reasonsToMap.map(({ code, label }) => (
              <Radio key={code} value={code}>
                {t(label)}
              </Radio>
            ))}
          </SimpleGrid>
        </RadioGroup>
      </ModalBody>
      <ModalFooter>
        <Button mr="4" onClick={handleOnClose} variant="outlinedBig">
          {t('cancelModal.neverMind')}
        </Button>
        <Button
          isDisabled={isEmpty(reason)}
          onClick={handleMainButtonClick}
          variant="blackBig"
        >
          {t('cancelModal.continue')}
        </Button>
      </ModalFooter>
    </>
  );
};

export default ReasonSelectorModal;
